export default function getTreeItems() {
    return [
        {
            id: 'a1d1da1e6d434902a2e5ffed7784c951',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: null,
            parentVersionId: null,
            afterCategoryId: null,
            afterCategoryVersionId: null,
            mediaId: null,
            displayNestedProducts: true,
            autoIncrement: 1,
            breadcrumb: ['Home'],
            level: 1,
            path: null,
            childCount: 2,
            data: {
                parentId: null,
                childCount: 2,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Home',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description: null,
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:26:01.950+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home'],
                name: 'Home',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description: null,
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [
                {
                    id: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                    versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                    parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    afterCategoryId: null,
                    afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    mediaId: '111dca5d5c64499c8a5008df0eb2a5e3',
                    displayNestedProducts: true,
                    autoIncrement: 2,
                    breadcrumb: ['Home', 'Health & Games'],
                    level: 2,
                    path: '|a1d1da1e6d434902a2e5ffed7784c951|',
                    childCount: 5,
                    data: {
                        parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                        childCount: 5,
                    },
                    type: 'page',
                    productAssignmentType: 'product',
                    visible: true,
                    active: true,
                    name: 'Health & Games',
                    customFields: null,
                    slotConfig: null,
                    linkType: null,
                    internalLink: null,
                    externalLink: null,
                    linkNewTab: null,
                    description:
                        'Temporibus adipisci minima ducimus fugit facere sint. Quibusdam voluptas ratione numquam maxime. Possimus placeat dolores eum itaque non.',
                    metaTitle: null,
                    metaDescription: null,
                    keywords: null,
                    cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
                    cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    productStreamId: null,
                    createdAt: '2021-06-17T06:27:07.267+00:00',
                    updatedAt: null,
                    translated: {
                        breadcrumb: ['Home', 'Health & Games'],
                        name: 'Health & Games',
                        customFields: [],
                        slotConfig: null,
                        linkType: null,
                        internalLink: null,
                        externalLink: null,
                        linkNewTab: null,
                        description:
                            'Temporibus adipisci minima ducimus fugit facere sint. Quibusdam voluptas ratione numquam maxime. Possimus placeat dolores eum itaque non.',
                        metaTitle: null,
                        metaDescription: null,
                        keywords: null,
                    },
                    apiAlias: null,
                    children: [],
                    translations: [],
                    products: [],
                    nestedProducts: [],
                    tags: [],
                    navigationSalesChannels: [],
                    footerSalesChannels: [],
                    serviceSalesChannels: [],
                    mainCategories: [],
                    seoUrls: [],
                },
                {
                    id: '8da86665f27740dd8160c92e27b1c4c8',
                    versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                    parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    afterCategoryId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                    afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    mediaId: 'f2d05d5c84c8400f8e0cda5889481351',
                    displayNestedProducts: true,
                    autoIncrement: 3,
                    breadcrumb: ['Home', 'Shoes'],
                    level: 2,
                    path: '|a1d1da1e6d434902a2e5ffed7784c951|',
                    childCount: 12,
                    data: {
                        parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                        childCount: 12,
                    },
                    type: 'page',
                    productAssignmentType: 'product',
                    visible: true,
                    active: true,
                    name: 'Shoes',
                    customFields: null,
                    slotConfig: null,
                    linkType: null,
                    internalLink: null,
                    externalLink: null,
                    linkNewTab: null,
                    description:
                        'Illum nihil labore exercitationem eos. Veritatis nihil mollitia eos aperiam voluptas. Occaecati odio numquam mollitia laborum nobis rerum veritatis.',
                    metaTitle: null,
                    metaDescription: null,
                    keywords: null,
                    cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
                    cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    productStreamId: null,
                    createdAt: '2021-06-17T06:27:07.268+00:00',
                    updatedAt: null,
                    translated: {
                        breadcrumb: ['Home', 'Shoes'],
                        name: 'Shoes',
                        customFields: [],
                        slotConfig: null,
                        linkType: null,
                        internalLink: null,
                        externalLink: null,
                        linkNewTab: null,
                        description:
                            'Illum nihil labore exercitationem eos. Veritatis nihil mollitia eos aperiam voluptas. Occaecati odio numquam mollitia laborum nobis rerum veritatis.',
                        metaTitle: null,
                        metaDescription: null,
                        keywords: null,
                    },
                    apiAlias: null,
                    children: [],
                    translations: [],
                    products: [],
                    nestedProducts: [],
                    tags: [],
                    navigationSalesChannels: [],
                    footerSalesChannels: [],
                    serviceSalesChannels: [],
                    mainCategories: [],
                    seoUrls: [],
                },
            ],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [
                {
                    typeId: 'f183ee5650cf4bdb8a774337575067a6',
                    languageId: '2fbb5fe2e29a4d70aa5854ce7ce3e20b',
                    customerGroupId: 'cfbd5018d38d41d8adca10d94fc8bdd6',
                    currencyId: 'b7d2554b0ce847cd82f3ac9bd1c0dfca',
                    paymentMethodId: '0f2e360d9c114a1f8eb2c705ee8ed46b',
                    shippingMethodId: 'efe98192f0654e87a1b3ff91a92ac6d5',
                    countryId: 'baa39a0184f24bb485e82fc30d760b5a',
                    analyticsId: null,
                    navigationCategoryId: 'a1d1da1e6d434902a2e5ffed7784c951',
                    navigationCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    navigationCategoryDepth: 2,
                    footerCategoryId: null,
                    footerCategoryVersionId: null,
                    serviceCategoryId: null,
                    serviceCategoryVersionId: null,
                    mailHeaderFooterId: null,
                    hreflangDefaultDomainId: null,
                    name: 'Headless',
                    shortName: null,
                    taxCalculationType: 'horizontal',
                    accessKey: 'SWSCCGPDR2VHSNRZAWRUCJU1YW',
                    configuration: null,
                    active: true,
                    hreflangActive: false,
                    maintenance: false,
                    // eslint-disable-next-line inclusive-language/use-inclusive-words
                    maintenanceIpWhitelist: null,
                    customFields: null,
                    paymentMethodIds: [
                        '04c5cd32601941078fa77eec6cc54275',
                        '0f2e360d9c114a1f8eb2c705ee8ed46b',
                        '5c480716167f45daa0ca43b15f2b1f1d',
                        'ea3009f552794bd2b73bcb4e2970a910',
                    ],
                    homeCmsPageId: null,
                    homeCmsPageVersionId: null,
                    homeSlotConfig: null,
                    homeEnabled: true,
                    homeName: null,
                    homeMetaTitle: null,
                    homeMetaDescription: null,
                    homeKeywords: null,
                    createdAt: '2021-06-17T06:26:01.961+00:00',
                    updatedAt: null,
                    translated: {
                        name: 'Headless',
                        customFields: [],
                        homeSlotConfig: null,
                        homeEnabled: true,
                        homeName: null,
                        homeMetaTitle: null,
                        homeMetaDescription: null,
                        homeKeywords: null,
                    },
                    apiAlias: null,
                    id: '98432def39fc4624b33213a56b8c944d',
                    translations: [],
                    currencies: [],
                    languages: [],
                    countries: [],
                    paymentMethods: [],
                    shippingMethods: [],
                    orders: [],
                    customers: [],
                    domains: [],
                    systemConfigs: [],
                    productVisibilities: [],
                    newsletterRecipients: [],
                    numberRangeSalesChannels: [],
                    promotionSalesChannels: [],
                    documentBaseConfigSalesChannels: [],
                    productReviews: [],
                    seoUrls: [],
                    seoUrlTemplates: [],
                    mainCategories: [],
                    productExports: [],
                    customerGroupsRegistrations: [],
                    landingPages: [],
                    boundCustomers: [],
                    wishlists: [],
                    extensions: { themes: [] },
                },
                {
                    typeId: '8a243080f92e4c719546314b577cf82b',
                    languageId: '2fbb5fe2e29a4d70aa5854ce7ce3e20b',
                    customerGroupId: 'cfbd5018d38d41d8adca10d94fc8bdd6',
                    currencyId: 'b7d2554b0ce847cd82f3ac9bd1c0dfca',
                    paymentMethodId: '0f2e360d9c114a1f8eb2c705ee8ed46b',
                    shippingMethodId: 'efe98192f0654e87a1b3ff91a92ac6d5',
                    countryId: 'baa39a0184f24bb485e82fc30d760b5a',
                    analyticsId: null,
                    navigationCategoryId: 'a1d1da1e6d434902a2e5ffed7784c951',
                    navigationCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    navigationCategoryDepth: 2,
                    footerCategoryId: null,
                    footerCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    serviceCategoryId: null,
                    serviceCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    mailHeaderFooterId: null,
                    hreflangDefaultDomainId: null,
                    name: 'Storefront',
                    shortName: null,
                    taxCalculationType: 'horizontal',
                    accessKey: 'SWSCDLJPNUPVDJHLZWX6D1FWNA',
                    configuration: null,
                    active: true,
                    hreflangActive: false,
                    maintenance: false,
                    // eslint-disable-next-line inclusive-language/use-inclusive-words
                    maintenanceIpWhitelist: null,
                    customFields: null,
                    paymentMethodIds: [
                        '04c5cd32601941078fa77eec6cc54275',
                        '0f2e360d9c114a1f8eb2c705ee8ed46b',
                        '5c480716167f45daa0ca43b15f2b1f1d',
                        'ea3009f552794bd2b73bcb4e2970a910',
                    ],
                    homeCmsPageId: null,
                    homeCmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
                    homeSlotConfig: null,
                    homeEnabled: true,
                    homeName: null,
                    homeMetaTitle: null,
                    homeMetaDescription: null,
                    homeKeywords: null,
                    createdAt: '2021-06-17T06:26:33.374+00:00',
                    updatedAt: null,
                    translated: {
                        name: 'Storefront',
                        customFields: [],
                        homeSlotConfig: null,
                        homeEnabled: true,
                        homeName: null,
                        homeMetaTitle: null,
                        homeMetaDescription: null,
                        homeKeywords: null,
                    },
                    apiAlias: null,
                    id: 'ab215e60e31f4aeebdbe5b42d3a5ff75',
                    translations: [],
                    currencies: [],
                    languages: [],
                    countries: [],
                    paymentMethods: [],
                    shippingMethods: [],
                    orders: [],
                    customers: [],
                    domains: [],
                    systemConfigs: [],
                    productVisibilities: [],
                    newsletterRecipients: [],
                    numberRangeSalesChannels: [],
                    promotionSalesChannels: [],
                    documentBaseConfigSalesChannels: [],
                    productReviews: [],
                    seoUrls: [],
                    seoUrlTemplates: [],
                    mainCategories: [],
                    productExports: [],
                    customerGroupsRegistrations: [],
                    landingPages: [],
                    boundCustomers: [],
                    wishlists: [],
                    extensions: { themes: [] },
                },
            ],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: null,
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '111dca5d5c64499c8a5008df0eb2a5e3',
            displayNestedProducts: true,
            autoIncrement: 2,
            breadcrumb: ['Home', 'Health & Games'],
            level: 2,
            path: '|a1d1da1e6d434902a2e5ffed7784c951|',
            childCount: 5,
            data: {
                parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                childCount: 5,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Health & Games',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Temporibus adipisci minima ducimus fugit facere sint. Quibusdam voluptas ratione numquam maxime. Possimus placeat dolores eum itaque non.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.267+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games'],
                name: 'Health & Games',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Temporibus adipisci minima ducimus fugit facere sint. Quibusdam voluptas ratione numquam maxime. Possimus placeat dolores eum itaque non.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'f547f999d3714a3aa620e02e7e299cc5',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '37a310885dce42169848338ec1fe9d73',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '568ac2202943436780f6744c770eb52a',
            displayNestedProducts: true,
            autoIncrement: 10,
            breadcrumb: ['Home', 'Health & Games', 'Electronics & Games'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|d3aabfa637cf435e8ad3c9bf1d2de565|',
            childCount: 0,
            data: {
                parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Electronics & Games',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Unde dolorem sunt in rem quia. Eos reprehenderit ut suscipit doloremque nulla. Temporibus quia inventore vel at. Molestiae harum sint minus commodi molestias.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.271+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games', 'Electronics & Games'],
                name: 'Electronics & Games',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Unde dolorem sunt in rem quia. Eos reprehenderit ut suscipit doloremque nulla. Temporibus quia inventore vel at. Molestiae harum sint minus commodi molestias.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'c03fdf1aaa534b7f8631bf16705ef213',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '82dcfd4ada3e41a1a2451b9cbfb1ad81',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'bae1546995f0431fb335a1784fe0c497',
            displayNestedProducts: true,
            autoIncrement: 12,
            breadcrumb: ['Home', 'Health & Games', 'Clothing & Grocery'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|d3aabfa637cf435e8ad3c9bf1d2de565|',
            childCount: 0,
            data: {
                parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Clothing & Grocery',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Modi odio iure unde error in voluptatem. Eligendi expedita vel ex sunt maxime labore. Ex veniam est occaecati molestiae sint. Voluptatem non blanditiis eum est.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.272+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games', 'Clothing & Grocery'],
                name: 'Clothing & Grocery',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Modi odio iure unde error in voluptatem. Eligendi expedita vel ex sunt maxime labore. Ex veniam est occaecati molestiae sint. Voluptatem non blanditiis eum est.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '82dcfd4ada3e41a1a2451b9cbfb1ad81',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'f547f999d3714a3aa620e02e7e299cc5',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '42d2245b0ee74ccab0180e3c2e33a5b9',
            displayNestedProducts: true,
            autoIncrement: 11,
            breadcrumb: ['Home', 'Health & Games', 'Baby, Health & Garden'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|d3aabfa637cf435e8ad3c9bf1d2de565|',
            childCount: 0,
            data: {
                parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Baby, Health & Garden',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Consequatur quae consectetur veritatis consectetur ducimus minima. Cupiditate consequatur officiis nemo quos rerum. Dolore dolores dolores in voluptas voluptatibus voluptas.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.271+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games', 'Baby, Health & Garden'],
                name: 'Baby, Health & Garden',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Consequatur quae consectetur veritatis consectetur ducimus minima. Cupiditate consequatur officiis nemo quos rerum. Dolore dolores dolores in voluptas voluptatibus voluptas.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '37a310885dce42169848338ec1fe9d73',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: null,
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'ee3ff68b556041fa83bb1c5e8b809040',
            displayNestedProducts: true,
            autoIncrement: 9,
            breadcrumb: ['Home', 'Health & Games', 'Automotive'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|d3aabfa637cf435e8ad3c9bf1d2de565|',
            childCount: 0,
            data: {
                parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Automotive',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Repudiandae voluptates aliquid facilis totam illo. Velit est et quod molestias. Atque sed ea consequatur accusamus omnis impedit.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.270+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games', 'Automotive'],
                name: 'Automotive',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Repudiandae voluptates aliquid facilis totam illo. Velit est et quod molestias. Atque sed ea consequatur accusamus omnis impedit.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '154766d843954ea79bd370c4de42e0c4',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'c03fdf1aaa534b7f8631bf16705ef213',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '7b1c714879af4198818e2227c83659be',
            displayNestedProducts: true,
            autoIncrement: 13,
            breadcrumb: ['Home', 'Health & Games', 'Toys, Health & Music'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|d3aabfa637cf435e8ad3c9bf1d2de565|',
            childCount: 0,
            data: {
                parentId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Toys, Health & Music',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Quaerat dolores quas neque sit inventore error. Sunt impedit ut odit voluptates. Voluptas mollitia adipisci aliquid omnis. Temporibus laudantium eligendi iure error nihil.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.272+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Health & Games', 'Toys, Health & Music'],
                name: 'Toys, Health & Music',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Quaerat dolores quas neque sit inventore error. Sunt impedit ut odit voluptates. Voluptas mollitia adipisci aliquid omnis. Temporibus laudantium eligendi iure error nihil.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '8da86665f27740dd8160c92e27b1c4c8',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'd3aabfa637cf435e8ad3c9bf1d2de565',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'f2d05d5c84c8400f8e0cda5889481351',
            displayNestedProducts: true,
            autoIncrement: 3,
            breadcrumb: ['Home', 'Shoes'],
            level: 2,
            path: '|a1d1da1e6d434902a2e5ffed7784c951|',
            childCount: 12,
            data: {
                parentId: 'a1d1da1e6d434902a2e5ffed7784c951',
                childCount: 12,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Shoes',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Illum nihil labore exercitationem eos. Veritatis nihil mollitia eos aperiam voluptas. Occaecati odio numquam mollitia laborum nobis rerum veritatis.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.268+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes'],
                name: 'Shoes',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Illum nihil labore exercitationem eos. Veritatis nihil mollitia eos aperiam voluptas. Occaecati odio numquam mollitia laborum nobis rerum veritatis.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '02547a0b1c92411eb7ddb81e67f81f90',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '42e05522afbd4a8183f143318c2fc4ca',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'de1f5edb53244f8eb7dc869a24447565',
            displayNestedProducts: true,
            autoIncrement: 15,
            breadcrumb: ['Home', 'Shoes', 'Kids, Tools & Shoes'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Kids, Tools & Shoes',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Expedita esse in vel. Nam sed cum dicta reprehenderit velit. Eum est consequuntur ut eos. In molestias veritatis rerum beatae. Aperiam nam adipisci quibusdam qui ipsam.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.273+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Kids, Tools & Shoes'],
                name: 'Kids, Tools & Shoes',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Expedita esse in vel. Nam sed cum dicta reprehenderit velit. Eum est consequuntur ut eos. In molestias veritatis rerum beatae. Aperiam nam adipisci quibusdam qui ipsam.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '1ca968936d324f74933ee08abc1c646e',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'a6a951fa633b4583b973cd69e567f9f1',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '596f2b3b4ada4e0b9e788324ced88bd9',
            displayNestedProducts: true,
            autoIncrement: 18,
            breadcrumb: ['Home', 'Shoes', 'Sports, Electronics & Jewelry'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Sports, Electronics & Jewelry',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Consectetur dolor facere voluptas voluptates. Fugiat consequuntur nulla voluptatem. Dicta illum quas officiis quas.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.275+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Sports, Electronics & Jewelry'],
                name: 'Sports, Electronics & Jewelry',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Consectetur dolor facere voluptas voluptates. Fugiat consequuntur nulla voluptatem. Dicta illum quas officiis quas.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '3cc35d190b6c4b68bf6abec4a14014b5',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '02547a0b1c92411eb7ddb81e67f81f90',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '06e44be26ddc412fa2a8174323aeca39',
            displayNestedProducts: true,
            autoIncrement: 16,
            breadcrumb: ['Home', 'Shoes', 'Grocery, Electronics & Clothing'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Grocery, Electronics & Clothing',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Omnis sunt labore mollitia voluptates non qui. Et voluptas qui id aspernatur et. Et vel ducimus perspiciatis facere. Possimus libero omnis perspiciatis quo asperiores.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.274+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Grocery, Electronics & Clothing'],
                name: 'Grocery, Electronics & Clothing',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Omnis sunt labore mollitia voluptates non qui. Et voluptas qui id aspernatur et. Et vel ducimus perspiciatis facere. Possimus libero omnis perspiciatis quo asperiores.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '4031f4e5b42c4aefa83b45a1141f70ad',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'edd7b5fd00814cac8586c4002d5f8710',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '6e8a3e178cb34fb4a8db8113a30025ac',
            displayNestedProducts: true,
            autoIncrement: 25,
            breadcrumb: ['Home', 'Shoes', 'Computers'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Computers',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Ex qui rem facilis. Est ratione provident error quis. Molestiae aut eveniet tempore nemo optio. Totam vitae sit culpa.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.277+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Computers'],
                name: 'Computers',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Ex qui rem facilis. Est ratione provident error quis. Molestiae aut eveniet tempore nemo optio. Totam vitae sit culpa.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '42e05522afbd4a8183f143318c2fc4ca',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: null,
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '3f8fc6b8b6a54e0491e6c3512899ef96',
            displayNestedProducts: true,
            autoIncrement: 14,
            breadcrumb: ['Home', 'Shoes', 'Sports'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Sports',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Expedita omnis blanditiis sapiente quam id. Sed et corrupti amet accusantium cumque. Ad et similique doloribus. Ea ducimus sint consequatur ea repellat.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.273+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Sports'],
                name: 'Sports',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Expedita omnis blanditiis sapiente quam id. Sed et corrupti amet accusantium cumque. Ad et similique doloribus. Ea ducimus sint consequatur ea repellat.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '4b0e9b4c59e641ca915fe916a66de894',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '4eaa55866a24411cb1e9be12d182799f',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '8e134225a80a46b4b328c9d037cab4b6',
            displayNestedProducts: true,
            autoIncrement: 23,
            breadcrumb: ['Home', 'Shoes', 'Grocery'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Grocery',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Magnam et officia beatae reiciendis. Iusto minus doloremque autem fugiat. Explicabo ut illum quisquam ratione quisquam ipsum deleniti. Aspernatur et odio quos dolor tenetur numquam.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.277+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Grocery'],
                name: 'Grocery',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Magnam et officia beatae reiciendis. Iusto minus doloremque autem fugiat. Explicabo ut illum quisquam ratione quisquam ipsum deleniti. Aspernatur et odio quos dolor tenetur numquam.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '4eaa55866a24411cb1e9be12d182799f',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'ac708d3f3e3f43d09949168bdc825095',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '8882a3b1e4694f68a4a16c525b539ddb',
            displayNestedProducts: true,
            autoIncrement: 22,
            breadcrumb: ['Home', 'Shoes', 'Movies, Computers & Tools'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Movies, Computers & Tools',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Ab excepturi laboriosam et quaerat. Odio dignissimos quasi est quia ut voluptatibus. Quis tempore hic repudiandae qui voluptatibus.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.276+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Movies, Computers & Tools'],
                name: 'Movies, Computers & Tools',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Ab excepturi laboriosam et quaerat. Odio dignissimos quasi est quia ut voluptatibus. Quis tempore hic repudiandae qui voluptatibus.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: '672af2c32c22402dabbfd9ab9343e211',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '1ca968936d324f74933ee08abc1c646e',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '6762e92561274bf18b74dd46ac2bdd36',
            displayNestedProducts: true,
            autoIncrement: 19,
            breadcrumb: ['Home', 'Shoes', 'Tools & Home'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Tools & Home',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Temporibus quia accusantium dolores aspernatur. Ea cumque quia dolor sed impedit.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.275+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Tools & Home'],
                name: 'Tools & Home',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Temporibus quia accusantium dolores aspernatur. Ea cumque quia dolor sed impedit.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'a6a951fa633b4583b973cd69e567f9f1',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '3cc35d190b6c4b68bf6abec4a14014b5',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'dc9d844b7d3a45899bb751d150d219ff',
            displayNestedProducts: true,
            autoIncrement: 17,
            breadcrumb: ['Home', 'Shoes', 'Music, Grocery & Computers'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Music, Grocery & Computers',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Repellat quia dolores alias perspiciatis facilis. Voluptate porro cupiditate sunt error consequatur qui. Aut soluta eligendi accusantium unde illo qui quis.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.274+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Music, Grocery & Computers'],
                name: 'Music, Grocery & Computers',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Repellat quia dolores alias perspiciatis facilis. Voluptate porro cupiditate sunt error consequatur qui. Aut soluta eligendi accusantium unde illo qui quis.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'ac708d3f3e3f43d09949168bdc825095',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: 'b4c10cda5f47464eb9e53ceaf687a984',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'bf7418a3af8c4f99829520caf72a2260',
            displayNestedProducts: true,
            autoIncrement: 21,
            breadcrumb: ['Home', 'Shoes', 'Home'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Home',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Sunt quaerat cupiditate ducimus dicta tempora praesentium doloribus. Aut quo libero qui deleniti occaecati modi. Quae voluptatem aut dolor dolorem delectus fugit.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.276+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Home'],
                name: 'Home',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Sunt quaerat cupiditate ducimus dicta tempora praesentium doloribus. Aut quo libero qui deleniti occaecati modi. Quae voluptatem aut dolor dolorem delectus fugit.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'b4c10cda5f47464eb9e53ceaf687a984',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '672af2c32c22402dabbfd9ab9343e211',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: 'ec05c45d81494a05a24f2dd0a0bd6126',
            displayNestedProducts: true,
            autoIncrement: 20,
            breadcrumb: ['Home', 'Shoes', 'Movies'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Movies',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Recusandae sequi voluptatem odit esse eos voluptates. Nostrum aut excepturi qui rem et. Temporibus quaerat nihil eos et placeat reiciendis.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'a4aaaa76a546453da734a3f0cee2f9d4',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.275+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Movies'],
                name: 'Movies',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Recusandae sequi voluptatem odit esse eos voluptates. Nostrum aut excepturi qui rem et. Temporibus quaerat nihil eos et placeat reiciendis.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
        {
            id: 'edd7b5fd00814cac8586c4002d5f8710',
            versionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            parentId: '8da86665f27740dd8160c92e27b1c4c8',
            parentVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            afterCategoryId: '4b0e9b4c59e641ca915fe916a66de894',
            afterCategoryVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            mediaId: '3ea821a7fb2f4056a4b4c056b65c80ed',
            displayNestedProducts: true,
            autoIncrement: 24,
            breadcrumb: ['Home', 'Shoes', 'Movies & Shoes'],
            level: 3,
            path:
                '|a1d1da1e6d434902a2e5ffed7784c951|8da86665f27740dd8160c92e27b1c4c8|',
            childCount: 0,
            data: {
                parentId: '8da86665f27740dd8160c92e27b1c4c8',
                childCount: 0,
            },
            type: 'page',
            productAssignmentType: 'product',
            visible: true,
            active: true,
            name: 'Movies & Shoes',
            customFields: null,
            slotConfig: null,
            linkType: null,
            internalLink: null,
            externalLink: null,
            linkNewTab: null,
            description:
                'Ut minus ut est ducimus id. Earum consectetur quod quis dolor. Est quis dolores consequatur reiciendis mollitia sed dignissimos.',
            metaTitle: null,
            metaDescription: null,
            keywords: null,
            cmsPageId: 'eef7acaf69f547b0a27fbc239a75ee4b',
            cmsPageVersionId: '0fa91ce3e96a4bc2be4bd9ce752c3425',
            productStreamId: null,
            createdAt: '2021-06-17T06:27:07.277+00:00',
            updatedAt: null,
            translated: {
                breadcrumb: ['Home', 'Shoes', 'Movies & Shoes'],
                name: 'Movies & Shoes',
                customFields: [],
                slotConfig: null,
                linkType: null,
                internalLink: null,
                externalLink: null,
                linkNewTab: null,
                description:
                    'Ut minus ut est ducimus id. Earum consectetur quod quis dolor. Est quis dolores consequatur reiciendis mollitia sed dignissimos.',
                metaTitle: null,
                metaDescription: null,
                keywords: null,
            },
            apiAlias: null,
            children: [],
            translations: [],
            products: [],
            nestedProducts: [],
            tags: [],
            navigationSalesChannels: [],
            footerSalesChannels: [],
            serviceSalesChannels: [],
            mainCategories: [],
            seoUrls: [],
        },
    ];
}
